import * as React from "react";

function BullhornIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'current',
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    width: props.width || '32px'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'current',
    fillRule: "evenodd",
    d: "M28 26V6h-2v1.983L6.773 11.48a4.595 4.595 0 000 9.041L8 20.744V23a3 3 0 003 3h7a3 3 0 002.998-2.893l5.002.91V26h2zm-2-4.017l-18.87-3.43a2.595 2.595 0 010-5.107L26 10.017v11.967zm-16-.876l9 1.636V23a1 1 0 01-1 1h-7a1 1 0 01-1-1v-1.893z",
    clipRule: "evenodd"
  }));
}

export default BullhornIcon;